













import { Vue, Prop, Component } from 'vue-property-decorator'

  @Component({
    name: 'MainTitle'
  })
export default class extends Vue {
    @Prop({ required: true }) private title!: string
    @Prop({ default: '#00B66C' }) private borderColor!: string
    @Prop({ default: 'dashed' }) private borerStyle!: string
    @Prop({ default: 'transparent' }) private bgColor!: string
    @Prop({ default: '#333' }) private textColor!: string
    @Prop({ default: '14px' }) private fontSize!: string
    @Prop({ default: 'horizontal' }) private direction!: string // vertical 竖向
}
